import React, {useState} from 'react';
import {Route} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import FriendList from '../container/Friend/List';
import {QUERY_USER} from '../container/Client/graphql';
import TalkSave from '../container/Talk/Save';
import TalkDetail from '../container/Talk/Detail';

const RootSpeaking = ({match}) => {
  const {user} = useQuery(QUERY_USER).data;

  const [showInfo, setShowInfo] = useState(!localStorage.getItem('alertedSpeaking@quiz-client'));

  return (
    <div>
      {showInfo && (
        <div className="alert alert-info text-center mt-4">
          <div>В разделе Беседа собраны темы и вопросы для практики разговорной речи</div>
          <button
            onClick={() => {
              setShowInfo(false);
              localStorage.setItem('alertedSpeaking@quiz-client', true);
            }}
            type="button"
            className="btn btn-light btn-sm mt-2"
          >
            <span>Закрыть</span>
          </button>
        </div>
      )}
      <div>
        <Route exact path={match.url}>
          {user.client.talkingId ? <TalkDetail id={user.client.talkingId} /> : <TalkSave />}
        </Route>
        <Route exact path={`${match.url}/friends`} component={FriendList} />
      </div>
    </div>
  );
};

export default RootSpeaking;
